import React from 'react'
import { SegmentedToggle as UiSegmentedToggle } from '../../../ui'

/**
 * Prep-card-local segmented toggle. Composes the UI primitive with a free-text
 * note input below it. The value shape is `{ direction, note }`.
 *
 * Uses the dark-inverted active state from the primitive — the previous
 * blue accent (PREP_COLOR `#3b82c4`) is intentionally dropped in favour of
 * the design system's standard segmented appearance.
 */
export function SegmentedToggle({ options, value, onChange, maxNoteChars = 140, disabled = false }) {
  const selected = value?.direction ?? null
  const note = value?.note ?? ''

  return (
    <div style={styles.wrap}>
      <UiSegmentedToggle
        ariaLabel="Direction"
        options={options}
        value={selected}
        onChange={(direction) => onChange({ direction, note })}
        disabled={disabled}
      />
      <input
        style={styles.noteInput}
        value={note}
        placeholder={disabled ? '' : 'What about?'}
        maxLength={maxNoteChars}
        disabled={disabled}
        onChange={(e) => !disabled && onChange({ direction: selected, note: e.target.value })}
        aria-label="What about?"
      />
    </div>
  )
}

const styles = {
  wrap: { padding: '10px 14px 12px', display: 'flex', flexDirection: 'column', gap: 10 },
  noteInput: {
    border: 'none',
    borderBottom: '1px solid var(--border)',
    outline: 'none',
    background: 'transparent',
    fontSize: 12,
    color: 'var(--text-primary)',
    padding: '2px 0',
    width: '100%',
    fontFamily: 'inherit',
  },
}
